import BasePerimeter from '@/kindergarten/perimeters/BasePerimiter';

export default new BasePerimeter({
  purpose: 'guest',

  can: {
    route() {
      return !this.child;
    },
  },
});



// WEBPACK FOOTER //
// ./src/kindergarten/perimeters/GuestPerimeter.js